export default __webpack_public_path__ + "assets/images/b65196d137d31fae48e39ae4d362fb3e-rejection_icon.svg";